module.exports = __webpack_public_path__ + "img/Quiet-Cove-015.5f9e9df8.jpg";